import DefaultLayout from "../../layout/default/DefaultLayout";
import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import ManualLayout from "../../layout/manual-layout/ManualLayout";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LoadingLayout from "../../layout/loading-layout/LoadingLayout";

const PageLoader = () => {
  const customerId = useSelector(
    (state) => state.customersReducer.nngWsCustomerId.value
  );
  const customerLoading = useSelector(
    (state) => state.customersReducer.nngWsCustomerId.loading
  );
  const pageLoading = useSelector(
    (state) => state.customersReducer.refreshCacheLoading
  );

  return (
    <DefaultLayout>
      <ManualLayout />
      {customerId === null && !pageLoading && !customerLoading ? (
        <Grid container mt={4} spacing={1} justifyItems={"center"}>
          <Grid item>
            <ErrorOutlineIcon fontSize={"large"} color={"primary"} />
          </Grid>
          <Grid item>
            <Typography variant={"h5"}>
              Errore durante l'ottenimento del codice cliente. Seleziona un
              nuovo cliente.
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <LoadingLayout />
      )}
    </DefaultLayout>
  );
};

export default PageLoader;
